import Swiper from "swiper";
import { Navigation } from 'swiper/modules';

/**
 * Initializes the mobile category carousel based on the viewport width and specific body attributes.
 * 
 * This function checks if the viewport width is less than or equal to 768px (indicating a mobile device)
 * 
 * The function initializes the Swiper carousel only if the number of slides exceeds a threshold 
 * and if the viewport width is mobile.
 */
export const initMobileCategoryCarousel = () => {
  const isMobile = window.innerWidth <= 768;
  const mobileCategoryCarouselContainer = document.querySelector('.carousel-category-mobile-container--swiper');
  if ( !mobileCategoryCarouselContainer ) return;

  const carouselContainer = mobileCategoryCarouselContainer.querySelector('.carousel-container');
  let { elementsCount:slidesQuantity} = carouselContainer ? carouselContainer.dataset : null;

  let mobileCarouselOptions = {
    modules: [Navigation],
    slidesPerView: 'auto',
    spaceBetween: 12,
    mousewheel: {
      forceToAxis: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  };
  if (isMobile && slidesQuantity > 4) {
    const swiper = new Swiper(mobileCategoryCarouselContainer, mobileCarouselOptions);
    const carouselContainer = mobileCategoryCarouselContainer.querySelector('.carousel-container');
    carouselContainer.classList.remove('gap');
  }
}